import { useEffect, useState } from "react";
import { Wallet2, Lock } from "lucide-react";
import api from "../../lib/api";
import LoyaltyManager from "../travel/LoyaltyManager";
import { WalletList } from "./WalletList";
import { WalletDashboard, ExpiringSoon, WalletActivity } from "./WalletPanels";
import PoolExtra from "./PoolDetails";

const TABS = [
  ["dashboard", "Dashboard"],
  ["programs", "Loyalty Programs"],
  ["pooling", "Miles Pooling"],
  ["benefits", "Benefits"],
  ["cards", "Credit Cards"],
  ["certificates", "Certificates"],
  ["credits", "Travel Credits"],
  ["codes", "Discount Codes"],
  ["expiring", "Expiring Soon"],
  ["activity", "Activity"],
];

const TAB_KIND = { pooling: "pool", benefits: "benefit", cards: "card", certificates: "certificate", credits: "credit", codes: "code" };

/* My Airline Loyalty & Benefits Wallet — the modular hub section. */
export default function BenefitsWallet() {
  const [tab, setTab] = useState(() => (window.location.hash === "#wallet" ? "dashboard" : "dashboard"));
  const [trips, setTrips] = useState([]);
  const [dashKey, setDashKey] = useState(0);

  useEffect(() => {
    api.get("/trips").then((r) => {
      const today = new Date().toISOString().slice(0, 10);
      const items = (r.data.items || []).filter((t) => !t.end_date || t.end_date >= today);
      setTrips(items.slice(0, 12));
    }).catch(() => setTrips([]));
  }, []);

  const nav = (t) => { setTab(t); setDashKey((k) => k + 1); };
  const kind = TAB_KIND[tab];

  return (
    <div id="wallet" data-testid="benefits-wallet">
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-heading font-900 text-[#F9AB00] text-2xl flex items-center gap-2">
          <Wallet2 className="w-6 h-6" /> My Airline Loyalty &amp; Benefits Wallet
        </h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4 flex items-center gap-1.5">
        <Lock className="w-3.5 h-3.5" /> Strictly private to you — never shown on public profiles, trips or community pages. Numbers &amp; codes are masked by default.
      </p>

      <div className="flex flex-wrap gap-1 border-b border-zinc-200 mb-5" data-testid="wallet-tabs">
        {TABS.map(([t, label]) => (
          <button key={t} onClick={() => nav(t)} data-testid={`wallet-tab-${t}`}
            className={`px-3 py-2 text-sm font-600 border-b-2 -mb-px transition-colors ${tab === t ? "border-[#F9AB00] text-zinc-900" : "border-transparent text-muted-foreground hover:text-zinc-900"}`}>
            {label}
          </button>
        ))}
      </div>

      {tab === "dashboard" && <WalletDashboard key={dashKey} onNavigate={nav} />}
      {tab === "programs" && <LoyaltyManager />}
      {tab === "expiring" && <ExpiringSoon onNavigate={nav} />}
      {tab === "activity" && <WalletActivity />}
      {kind && (
        <WalletList kind={kind} trips={trips}
          renderExtra={kind === "pool" ? (it, onChange) => <PoolExtra key={`x-${it.id}`} pool={it} onChange={onChange} /> : undefined} />
      )}
    </div>
  );
}
